import { ActionContext, ActionTree } from 'vuex';
import { RootState, ProfileState } from '../../types';
import userService from '@/services/user.service';

const actions: ActionTree<ProfileState, RootState> = {
  async update(store: ActionContext<ProfileState, RootState>): Promise<void> {
    store.commit('clearPutError');
    return userService
      .put(store.state.user)
      .then(response => {
        store.commit('auth/setUserData', response, { root: true });
        store.commit('set', response);
      })
      .catch(error => {
        store.commit('setPutError', error);
      });
  },
};

export default actions;
